import React from "react"
import { Link } from "react-router-dom";
import Modal from "../../../common/Modal/Modal";

export default function RegVerifyEmail(props) {
    return (
        <Modal className="login" >
            <p className="content2 light-black center-text gap-above-m" >A verification link has been sent to</p>
            <p className="content1 heavy center-text gap-below-xs gap-above-xs" >{props.revisedEmail ? props.revisedEmail + "@" + props.selectedCompany.domain : props.newUser.email}</p>
            <p className="content2 light-black center-text gap-below-l" >Please click the link in your email to complete your registration</p>
            <p className="content2 light text-center gap-below-s" >Remember to check your spam if you do not see the email</p>
            {/*<p className="content2 light text-center gap-below-s" >Didn't receive a link?</p>
            <p className="content2 light text-center gap-below-s" ><Link id="resend" to="" className="link2" style={{fontWeight:"bold"}}>Click here</Link> to resend</p>*/}
        </Modal>
    )
}
